import React from 'react';

import { IconProps, StyledPath, StyledSvg } from '../iconCommons';

export const IconSearch = ({ color = 'currentColor', size = 'small', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13" size={size} {...props}>
        <StyledPath
            d="M12.042 13a.954.954 0 00.682-.276.99.99 0 000-1.364L9.735 8.372A5.344 5.344 0 005.34 0 5.344 5.344 0 000 5.34a5.344 5.344 0 008.372 4.395l2.988 2.99a.954.954 0 00.682.275zM5.34 9.286a3.95 3.95 0 01-3.946-3.947A3.95 3.95 0 015.34 1.393a3.95 3.95 0 013.947 3.946A3.95 3.95 0 015.34 9.286z"
            color={color}
        />
    </StyledSvg>
);
